export default __webpack_public_path__ + "static/media/mast_icon.cb1e9fbf.svg";